// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"527":"298a1307","709":"18156879","935":"6c61d022"}[chunkId] + ".chunk.css";
};